import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';
import Slider from 'react-slick';

import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

const HomePartnersBuilder = ({ partnersHome }) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  return (
    <Slider {...settings}>
      {partnersHome.map((item, index) => (
        <div key={index}>
          {item.partnersLogosLogoLink ? (
            <a href={item.partnersLogosLogoLink} target='_blank'>
              <figure>
                <GatsbyImage
                  image={getImage(item.partnersLogosLogo.localFile)}
                  alt='image'
                />
              </figure>
            </a>
          ) : (
            <figure>
              <GatsbyImage
                image={getImage(item.partnersLogosLogo.localFile)}
                alt='image'
              />
            </figure>
          )}

        </div>
      ))}
    </Slider>
  );
};

export default HomePartnersBuilder;
